const API_URLS = {
  AUTH: {
    LOGIN: '/authenticate',
    VALIDATE_ACCESS_TOKEN: '/token/validate/',
    GET_NEW_ACCESS_TOKEN: '/refresh-token',
  },
  SCRIPTS: '/scripts',
  GLOBAL_SCRIPTS: '/global-scripts',
  EMAILS: '/emails',
  GLOBAL_EMAILS: '/global-emails',
  UPLOADS: '/upload',
  DNC: {
    BASE: '/personaldnc',
    BASE_DNC: '/personal-dnc',
    GLOBAL: '/globaldnc', // GLOBAL - Handle normal operations
    GLOBAL_DNC: '/global-dnc', // GLOBAL_DNC - Handle bulk operations
    PHONE: 'phone',
    PHONES: 'phones',
    VIEW: 'view',
    RESTORE: 'restore',
    EXPORT: 'export',
  },
  TAGS: '/user/tags',
  USERS: {
    GET_USERS: '/user/paginated',
  },
  REPORT: {
    SESSIONS: '/reports/sessions',
    CALL_LOG: '/reports/call-logs',
    SESSIONS_SUMMARY: '/reports/sessions-summary',
    PRINT_CALL_LOG: 'reports/print-call-log',
    PRINT_SESSION_SUMMARY: 'reports/print-sessions-summary',
    EXPORT_CALL_LOG: 'reports/export-call-log',
    EXPORT_SESSION_SUMMARY: 'reports/export-sessions-summary',
    ACTIVE_SESSIONS: '/reports/active-sessions',
    EMAIL_LOG: '/reports/email-logs',
  },
  USER_CALLER_IDS: {
    GET_CALLER_ID_LIST: '/caller-ids',
    VERIFY_CALLER_ID_TWILIO: '/caller-ids/twilio/verify',
    VERIFY_CALLER_ID_TELNYX: '/caller-ids/telnyx/verify',
    VERIFY_CALLER_ID_TELNYX_SUBMIT_CODE:
      '/caller-ids/telnyx/submit-verification-code',
    STIR_SHAKEN: '/sub-account/stir-shaken',
    SUPPORT_STIR_SHAKEN: '/sub-account/support-stir-shaken',
    DELETE_CALLER_BY_ID: '/caller-ids',
    VERIFY_CALLER_STATUS_BY_POLLING: '/caller-ids',
    GET_CALLER_ID_ROTATION_LIST: '/caller-ids-rotation',
    DELETE_ROTATION_CALLER_ID: '/caller-ids-rotation',
    VERIFY_ROTATION_CALLER_ID: '/caller-ids-rotation/verify',
    VERIFY_ROTATION_CALLER_STATUS_BY_POLLING: '/caller-ids-rotation',
    CHANGE_ENABLING_ROTATION_CALLER: '/caller-ids-rotation/change-enabling',
    GET_AREA_CODES: '/caller-ids-rotation/area-codes',
    FORWARDING_NUMBER: '/forwarding-number',
    SEND_SMS_FOR_NUMBER_SHARING: '/caller-ids/number-sharing-sms',
    NUMBER_SHARING_VALIDATION: '/caller-ids/number-sharing-validation',
    GET_TPR_SETTINGS: '/tpr-settings/available-and-used-amount',
    CHECK_CALLER_ID: '/caller-ids/check-caller-id',
    CHECK_CALLER_ID_FILE: '/caller-ids/check-caller-id-file',
  },
  SMTP_SETTINGS: {
    BASE: '/smtp-settings',
    VERIFICATION_SEND: '/smtp-settings/verification/send',
    VERIFY_TOKEN: '/smtp-settings/verification/token',
  },
  GROUPS: '/groups',
  SETTINGS: {
    ADMIN_SETTINGS: '/admin-settings',
    ADMIN_SETTINGS_TIME_FRAME: '/admin-settings/time-frame',
    ADMIN_SETTINGS_BLEED_OUT: '/admin-settings/bleed-out/get',
    ADMIN_SETTINGS_STATE_TSR: '/admin-settings/state-tsr',
    ADMIN_SETTINGS_CALL_MONITOR: '/admin-settings/call-monitor-percentage',
    USER_SETTINGS_CALL_RECORDING: '/user-settings/call-recording',
    USER_SETTINGS_VOICE_PROVIDER_OPTIONS:
      '/user-settings/voice-provider/options',
    USER_SETTINGS_DIALER_SUB_ACCOUNT: '/user-settings/dialer-sub-account',
    USER_SETTINGS_VOICE_PROVIDER: '/user-settings/voice-provider',
    ACCOUNT_SETTINGS: '/account-settings',
    GLOBAL_SETTINGS: '/admin-settings/global-settings',
    BUY_DIAL_IN_NUMBER: '/admin-settings/buy-dial-in-number',
  },
  DATA_INTEGRATION: {
    PERSONAL_DNC: '/data-integration/dnc/personal-dnc',
    GLOBAL_DNC: '/data-integration/dnc/global-dnc',
    GLOBAL_DNC_BULK: '/data-integration/dnc/global-dnc-bulk',
  },
};

export default API_URLS;
